import React, { useEffect } from "react";
import Header2 from "../../Layout/Header2";
import "./WinnersAboutUs.css";
import headlogo from "../../Images/Isolation_Mode.png";
import isolation from "../../Images/Isolation_Mode (1).png";
import isolation2 from "../../Images/Isolation_Mode (2).png";
import isolation3 from "../../Images/Isolation_Mode (3).png";
import img1 from "../../Images/Rectangle 20 (4).png";
import img2 from "../../Images/Rectangle 424.png";
import img3 from "../../Images/Rectangle 425.png";
import img4 from "../../Images/Rectangle 426.png";
import FavProperties from "./FavProperties";
import WinnersClient from "../WinnersHome/WinnersClient";
import Achievements from "./Achievements";
import WhyChooseUs from "./WhyChooseUs";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
const WinnersAboutUs = () => {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 699,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 499,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  useEffect(()=>{
    window.scrollTo({top:0,behavior:"instant"})
  },[])
  return (
    <>
      <section className="about_us_section">
        <div className="about_us_container">
          <Header2 />
          <div>
            <h1 className=" about_head">
              About Us
              <span>
                <img className="img_logo" src={headlogo} />
              </span>
            </h1>
            {/* <p className='about_head_para'>Lorem Ipsum placeholder text for use in your graphic, print and web layouts, and discover <br/> plugins for your favorite writing, design and blogging tools. </p> */}
            <p className="about_head_para"
            //  style={{ padding: "0 120px" }}
             >
              Who We Are – Your Trusted Real Estate Data Partner We are a real
              estate data provider company based in NCR, specializing in
              property listings, price trends, and verified sales & rental
              information owners properties data across Gurgaon, Noida, and
              South Delhi. Our mission is simple: Helping real estate
              professionals’ brokers, consultants with real time accurate data
              that drives results. No guesswork. No outdated information.
              Just pure, actionable insights to help you close deals faster.
              With years of experience and a growing network, we serve brokers,
              agencies, developers, and investors who need reliable data to
              scale their business. 👉 Because in real estate, information is
              everything — and we make sure you always have the right one.
            </p>
          </div>
          <img className="isolation_img_1" src={isolation} />
          <img className="isolation_img_2" src={isolation2} />
          <img className="isolation_img_3" src={isolation3} />

          <div className="about_images_div_wrapper">
            <Slider {...settings}>
              <div className="about_img_div_1" id="img1">
                <img src={img1} />
              </div>
              <div className="about_img_div_2" id="img2">
                <img src={img2} />
              </div>
              <div className="about_img_div_1" id="img3">
                <img src={img3} />
              </div>
              <div className="about_img_div_2" id="img4">
                <img src={img4} />
              </div>
            </Slider>
          </div>
        </div>
      </section>
      <FavProperties />
      <WinnersClient center={"center"} />
      <Achievements />
      <WhyChooseUs />
    </>
  );
};

export default WinnersAboutUs;
